import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { useFiles } from 'client/store'
import filesSelectors from 'client/store/files/filesSelectors'
import { EntityProps } from 'client/types'
import React from 'react'
import { WebsiteLogo as SharedLogo } from 'src/shared/entities/website-logo'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'

export const WebsiteLogo = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: EntityProps<WebsiteLogoInterface>) => {
  const file = useFiles(state =>
    filesSelectors.getFileById(state, entity.logoFileId),
  )

  const mobileFile = useFiles(state =>
    filesSelectors.getFileById(state, entity.mobileLogoFileId),
  )

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <SharedLogo
        {...entity}
        imageSrc={file?.path ?? ''}
        mobileImageSrc={mobileFile?.path ?? ''}
      />
    </BaseEntityNew>
  )
}
